import React from "react";
import "./style.scss";

export default function LinearProgressBar({
  value = 0,
  height = 10,
  customValue = null,
  startStepColor = "#00BDFF",
  endStepColor = "#F6B900",
  procentHide,
  vertical
}) {
  const valuePercentage = Math.min(value, 1) * 100;

  return (
    <div className={`linear-progress-bar-component ${vertical ? "vertical" : ""}`}>
      <div
        className="linear-progress-bar-inner"
        style={{ height: `${height}px` }}
      >
        <div
          className="track"
          style={{
            borderRadius: `${height / 2}px`,
            backgroundColor: "#e0e0e0",
          }}
        />
        <div
          className="fill"
          style={{
            width: `${customValue ? customValue : `${valuePercentage}%`}`,
            borderRadius: `${height / 2}px`,
            backgroundImage: `linear-gradient(90deg, ${startStepColor} 0%, ${endStepColor} 100%)`,
          }}
        />
      </div>
      {!customValue && !procentHide && (
        <span className="linear-progress-bar-percentage">
          {Math.floor(valuePercentage)}%
        </span>
      )}
    </div>
  );
}
